import React from 'react';

const OfflineFallback = () => {
  return (
    <div className="fixed inset-0 z-[9999] bg-white dark:bg-gray-900 flex flex-col items-center justify-center p-6 text-center">
      {/* Offline Icon Animation */}
      <div className="mb-8 relative">
        <div className="w-24 h-24 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center animate-pulse">
          <i className="fas fa-wifi text-4xl text-blue-500 opacity-30"></i>
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <i className="fas fa-slash text-5xl text-red-500 -rotate-45"></i>
        </div>
      </div>

      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
        You are offline
      </h1>
      
      <p className="text-lg text-gray-600 dark:text-gray-400 mb-8 max-w-md">
        It looks like you've lost your internet connection. Twachanga requires a network connection to sync your latest data.
      </p>

      <button 
        onClick={() => window.location.reload()}
        className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl shadow-lg transition-all flex items-center gap-2"
      >
        <i className="fas fa-sync-alt"></i>
        Try Again
      </button>

      <div className="absolute bottom-10 left-0 right-0 flex justify-center">
        <img 
          src="/logo192.png" 
          alt="Twachanga Logo" 
          className="w-12 h-12 opacity-50 grayscale"
        />
      </div>
    </div>
  );
};

export default OfflineFallback;
